export default "__VITE_ASSET__Eoz0y1zB__"